import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import SettingsCard from '../../../components/Settings/SettingsCard'
import BusinessStripeConnectSection from '../business-stripe-connect-section'

export default function BusinessVerificationCard({ businessId, ein }) {
  const { t } = useTranslation()

  return (
    <SettingsCard
      icon="building"
      title={t('business.stripe.title', 'Business Verification')}
    >
      <BusinessStripeConnectSection businessId={businessId} ein={ein} />
    </SettingsCard>
  )
}

BusinessVerificationCard.propTypes = {
  businessId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  ein: PropTypes.string,
}
